<div id="mauticform_wrapper_cadastroempresa2" class="mauticform_wrapper">
  <form
    #form
    autocomplete="false"
    role="form"
    method="post"
    action="{{ formApiUrl }}?formId=22"
    id="mauticform_cadastroempresa2"
    data-mautic-form="cadastroempresa2"
    enctype="multipart/form-data"
  >
    <div class="mauticform-error" id="mauticform_cadastroempresa2_error"></div>
    <div
      class="mauticform-message"
      id="mauticform_cadastroempresa2_message"
    ></div>
    <div class="mauticform-innerform">
      <div
        class="mauticform-page-wrapper mauticform-page-1"
        data-mautic-form-page="1"
      >
        <div
          id="mauticform_cadastroempresa2_nome_fantasia"
          data-validate="nome_fantasia"
          data-validation-type="text"
          class="mauticform-row mauticform-text mauticform-field-1 mauticform-required"
        >
          <input
            id="mauticform_input_cadastroempresa2_nome_fantasia"
            name="mauticform[nome_fantasia]"
            [value]="formData.businessName"
            class="mauticform-input"
            type="text"
          />
        </div>

        <div
          id="mauticform_cadastroempresa2_razao_social1"
          data-validate="razao_social1"
          data-validation-type="text"
          class="mauticform-row mauticform-text mauticform-field-13 mauticform-required"
        >
          <input
            id="mauticform_input_cadastroempresa2_razao_social1"
            name="mauticform[razao_social1]"
            [value]="formData.companyName"
            class="mauticform-input"
            type="text"
          />
        </div>

        <div
          id="mauticform_cadastroempresa2_cnpj"
          data-validate="cnpj"
          data-validation-type="text"
          class="mauticform-row mauticform-text mauticform-field-3 mauticform-required"
        >
          <input
            id="mauticform_input_cadastroempresa2_cnpj"
            name="mauticform[cnpj]"
            [value]="formData.cnpj"
            class="mauticform-input"
            type="text"
          />
        </div>

        <div
          id="mauticform_cadastroempresa2_ie"
          data-validate="ie"
          data-validation-type="text"
          class="mauticform-row mauticform-text mauticform-field-4 mauticform-required"
        >
          <input
            id="mauticform_input_cadastroempresa2_ie"
            name="mauticform[ie]"
            [value]="formData.ie"
            class="mauticform-input"
            type="text"
          />
        </div>

        <div
          id="mauticform_cadastroempresa2_im"
          data-validate="im"
          data-validation-type="text"
          class="mauticform-row mauticform-text mauticform-field-5 mauticform-required"
        >
          <input
            id="mauticform_input_cadastroempresa2_im"
            name="mauticform[im]"
            [value]="formData.im"
            class="mauticform-input"
            type="text"
          />
        </div>

        <div
          id="mauticform_cadastroempresa2_regime_tributario"
          data-validate="regime_tributario"
          data-validation-type="text"
          class="mauticform-row mauticform-text mauticform-field-6 mauticform-required"
        >
          <input
            id="mauticform_input_cadastroempresa2_regime_tributario"
            name="mauticform[regime_tributario]"
            [value]="formData.taxRegime"
            class="mauticform-input"
            type="text"
          />
        </div>

        <div
          id="mauticform_cadastroempresa2_cep"
          data-validate="cep"
          data-validation-type="text"
          class="mauticform-row mauticform-text mauticform-field-7 mauticform-required"
        >
          <input
            id="mauticform_input_cadastroempresa2_cep"
            name="mauticform[cep]"
            [value]="formData.zipCode"
            class="mauticform-input"
            type="text"
          />
        </div>

        <div
          id="mauticform_cadastroempresa2_estado"
          data-validate="estado"
          data-validation-type="text"
          class="mauticform-row mauticform-text mauticform-field-8 mauticform-required"
        >
          <input
            id="mauticform_input_cadastroempresa2_estado"
            name="mauticform[estado]"
            [value]="formData.stateName"
            class="mauticform-input"
            type="text"
          />
        </div>

        <div
          id="mauticform_cadastroempresa2_cidade"
          data-validate="cidade"
          data-validation-type="text"
          class="mauticform-row mauticform-text mauticform-field-9 mauticform-required"
        >
          <input
            id="mauticform_input_cadastroempresa2_cidade"
            name="mauticform[cidade]"
            [value]="formData.city + ', ' + formData.uf"
            class="mauticform-input"
            type="text"
          />
        </div>

        <div
          id="mauticform_cadastroempresa2_bairro"
          data-validate="bairro"
          data-validation-type="text"
          class="mauticform-row mauticform-text mauticform-field-10 mauticform-required"
        >
          <input
            id="mauticform_input_cadastroempresa2_bairro"
            name="mauticform[bairro]"
            [value]="formData.district"
            class="mauticform-input"
            type="text"
          />
        </div>

        <div
          id="mauticform_cadastroempresa2_logradouro"
          data-validate="logradouro"
          data-validation-type="text"
          class="mauticform-row mauticform-text mauticform-field-11 mauticform-required"
        >
          <input
            id="mauticform_input_cadastroempresa2_logradouro"
            name="mauticform[logradouro]"
            [value]="formData.street"
            class="mauticform-input"
            type="text"
          />
        </div>

        <div
          id="mauticform_cadastroempresa2_numero"
          data-validate="numero"
          data-validation-type="text"
          class="mauticform-row mauticform-text mauticform-field-12 mauticform-required"
        >
          <input
            id="mauticform_input_cadastroempresa2_numero"
            name="mauticform[numero]"
            [value]="formData.number"
            class="mauticform-input"
            type="text"
          />
        </div>

        <div
          id="mauticform_cadastroempresa2_complemento"
          data-validate="complemento"
          data-validation-type="text"
          class="mauticform-row mauticform-text mauticform-field-13 mauticform-required"
        >
          <input
            id="mauticform_input_cadastroempresa2_complemento"
            name="mauticform[complemento]"
            [value]="formData.complement"
            class="mauticform-input"
            type="text"
          />
        </div>

        <div
          id="mauticform_cadastroempresa2_email"
          data-validate="email"
          data-validation-type="email"
          class="mauticform-row mauticform-email mauticform-field-14 mauticform-required"
        >
          <input
            id="mauticform_input_cadastroempresa2_email"
            name="mauticform[email]"
            [value]="formData.email"
            class="mauticform-input"
            type="email"
          />
        </div>

        <div
          id="mauticform_cadastroempresa2_email_contato"
          data-validate="email_contato"
          data-validation-type="email"
          class="mauticform-row mauticform-email mauticform-field-15 mauticform-required"
        >
          <input
            id="mauticform_input_cadastroempresa2_email_contato"
            name="mauticform[email_contato]"
            [value]="formData.email"
            class="mauticform-input"
            type="email"
          />
        </div>

        <div id="mauticform_cadastroempresa2_telefone" class="mauticform-row mauticform-text mauticform-field-16">
          <input id="mauticform_input_cadastroempresa2_telefone" name="mauticform[telefone]" [value]="formData.phone" class="mauticform-input" type="text">  
        </div>

        <div
          id="mauticform_cadastroempresa2_submit"
          class="mauticform-row mauticform-button-wrapper mauticform-field-14"
        >
          <button
            type="submit"
            name="mauticform[submit]"
            id="mauticform_input_cadastroempresa2_submit"
            value=""
            class="mauticform-button btn btn-default"
          >
            Enviar
          </button>
        </div>
      </div>
    </div>

    <input
      type="hidden"
      name="mauticform[formId]"
      id="mauticform_cadastroempresa2_id"
      value="22"
    />
    <input
      type="hidden"
      name="mauticform[return]"
      id="mauticform_cadastroempresa2_return"
      value=""
    />
    <input
      type="hidden"
      name="mauticform[formName]"
      id="mauticform_cadastroempresa2_name"
      value="cadastroempresa2"
    />
  </form>
</div>
